import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
};

export default function ProfileupdateReducer(state = initialState, action) {
  switch (action.type) {
  
    case actionTypes.FETCH_PROFILECOUNTRY_SUCCESS_ACTION:
      return {
        ...state,
        countryprofdetailList: action.payload.rows,
      };
      case actionTypes.FETCH_REGION_SUCCESS_ACTION:
      return {
        ...state,
        regionList: action.payload.rows,
      };
    case actionTypes.FETCH_LOCATION_SUCCESS_ACTION:
      return {
        ...state,
        locationList: action.payload.rows,
      };
   
    default:
      return {
        ...state,
      };
  }
}
